export default "__VITE_PUBLIC_ASSET__092fba43__"